import React, { FC, memo, ReactNode } from 'react';

import { Alert as RaisinAlert, Typography } from '@raisin/components-lib';

export type AlertProps = {
  mode: 'information' | 'error' | 'success' | 'warning';
  title?: string | ReactNode;
  description?: string | ReactNode;
};

export const Alert: FC<AlertProps> = memo(({ mode = 'information', title, description }) => {
  if (!title && !description) return null;

  return (
    <RaisinAlert mode={mode}>
      {title && (
        <Typography mb={description ? '4px' : '0'} variant="subtitle1">
          {title}
        </Typography>
      )}
      {description && <Typography variant="body1">{description}</Typography>}
    </RaisinAlert>
  );
});

Alert.displayName = 'Alert';
